import { useState, useEffect } from "react"
import randomstring from "randomstring"

const getConfigTID = siteIdentifier => {
  const code_verifier = randomstring.generate(128)
  const client_id =
    process.env.GATSBY_ENV === "staging" ||
    process.env.GATSBY_ENV === "sketchup-staging"
      ? process.env.GATSBY_STAGING_CODE_ID_TID
      : process.env.GATSBY_PROD_CODE_ID_TID

  const url =
    process.env.GATSBY_ENV === "staging" ||
    process.env.GATSBY_ENV === "sketchup-staging"
      ? "https://stage.id.trimblecloud.com/oauth/token"
      : "https://id.trimble.com/oauth/token"

  const createUrl =
    process.env.GATSBY_ENV === "staging" ||
    process.env.GATSBY_ENV === "sketchup-staging"
      ? "https://stage.id.trimblecloud.com/oauth/"
      : "https://id.trimble.com/oauth/"

  const client_secret =
    process.env.GATSBY_ENV === "staging" ||
    process.env.GATSBY_ENV === "sketchup-staging"
      ? process.env.GATSBY_STAGING_CLIENT_SECRET_TID
      : process.env.GATSBY_PROD_CLIENT_SECRET_TID

  const redirect_uri =
    typeof window !== "undefined"
      ? `${window.location.origin}/login`
      : `http://localhost:8001/login`

  const queryString =
    process.env.GATSBY_ENV === "staging" ||
    process.env.GATSBY_ENV === "sketchup-staging"
      ? `https://stage.id.trimblecloud.com/oauth/authorize?scope=MXP_Demo%20openid%20TCMiddleware-SIT&response_type=code&redirect_uri=${redirect_uri}&client_id=48143bb4-2d81-4d09-899c-0992f82e9565&state=`
      : `https://id.trimble.com/oauth/authorize?scope=trimble-mxp-login%20TCMiddleware%20openid&response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}&state=`

  const signUpQuery =
    process.env.GATSBY_ENV === "staging" ||
    process.env.GATSBY_ENV === "sketchup-staging"
      ? `${createUrl}authorize?scope=openid MXP_Demo&response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}&prompt=create&state=`
      : `${createUrl}authorize?scope=openid trimble-mxp-login&response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}&prompt=create&state=`
  return {
    queryString,
    redirect_uri,
    code_verifier,
    client_id,
    url,
    client_secret,
    signUpQuery,
  }
}

export default getConfigTID
